import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShoppingCart, Wrench, Zap, Car, Users } from 'lucide-react';

const ServicesOverview = () => {
  const services = [
    {
      icon: ShoppingCart,
      title: "Tacoma Performance Parts",
      description: "Shop Online",
      color: "text-brandred"
    },
    {
      icon: Wrench,
      title: "In-House Product Design & Manufacturing",
      description: "Custom solutions",
      color: "text-brandred"
    },
    {
      icon: Zap,
      title: "Lighting, Suspension, Protection, Accessories",
      description: "Complete upgrades",
      color: "text-brandred"
    },
    {
      icon: Wrench,
      title: "Professional Installations in Chula Vista",
      description: "Expert service",
      color: "text-brandred"
    },
    {
      icon: Car,
      title: "Serving 1st–4th Gen Tacomas",
      description: "All generations",
      color: "text-brandred"
    },
    {
      icon: Users,
      title: "4Runner & Tundra Support Coming Soon",
      description: "Expanding soon",
      color: "text-gray-400"
    }
  ];

  return (
    <section 
      className="bg-white py-16 text-black border-t border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-black mb-4">
            What We <span className="text-brandred">Do</span>
          </h2>
          <p className="text-lg text-black max-w-2xl mx-auto">
            Your one-stop shop for everything Tacoma. From parts to installation, we've got you covered.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 relative"
              style={{ backgroundColor: '#ffffff' }}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <service.icon className={`${service.color}`} size={24} />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-black mb-1">
                    {service.title}
                  </h3>
                  <p className={`text-sm ${service.color === 'text-gray-400' ? 'text-gray-600' : 'text-brandred'} font-medium`}>
                    {service.description}
                  </p>
                </div>
                <Check className="text-green-500 absolute top-4 right-4" size={20} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview; 